import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import LocationLogApi from "api/locationLogApi";
import { formatQueryParams } from "helpers/format";
import chatLogApi from "api/chatLogApi";

export const getChatLogs = createAsyncThunk(
  "ChatLogs",
  async (params: any = {}) => {
    try {
      const response = await chatLogApi.chatLogs(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getChatGroupMessages = async (chat_id: string | number, params: any = {}) => {
  try {
    const response = await chatLogApi.chatGroupMessages(chat_id, formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};